import type { MatchConfig } from '@signalclash/shared';
import { MATCH_CONFIG_V0_3, MATCH_CONFIG_V0_4, MATCH_CONFIG_V1_5 } from '@signalclash/shared';

// V0.4 ships an 8-minute Practice match against the Recruit bot. V1.5 keeps
// the 8-minute length and enables Signal Links; the client default tracks the
// latest milestone, so V1.5+ matches start with the camp opt-in flag respected.
//
// Map selection: the player-facing default is Crucible (the 3000×2400 7-relay
// flagship map). MATCH_CONFIG_V1_5 still pins mapId: 'foundry' so the V1.5
// integration test suite — which hard-codes Foundry's 3-relay geometry —
// stays green, so we spread it and override mapId here. The server room does
// the same (apps/server/src/rooms/SignalClashRoom.ts).
//
// MATCH_CONFIG_V0_3 stays exported for tests that still want a 5-minute window
// without camps; MATCH_CONFIG_V0_4 stays for the camp-off V0.4 baseline.
export type { MatchConfig };
export { MATCH_CONFIG_V0_3, MATCH_CONFIG_V0_4, MATCH_CONFIG_V1_5 };

export const MATCH_CONFIG_DEFAULT: MatchConfig = Object.freeze({
  ...MATCH_CONFIG_V1_5,
  mapId: 'crucible',
});
